<i2g-company-logo
  [imageUrl]="companyLogoUrl"
  [imageAlt]="companyName"
  class="logo"
></i2g-company-logo>

<h1 class="title">{{ title }}</h1>

<h2 *ngIf="companyName" class="subtitle">{{ companyName }}</h2>

<div class="line"></div>

<i2g-form-master *ngIf="form" [form]="form" class="form">
  <div *ngFor="let item of ratings" class="rating-form-field-wrapper">
    <label class="rating-label">
      <div class="rating-category">{{ item.category }}</div>
      <div class="rating-category-question">{{ item.question }}</div>
    </label>
    <i2g-rating-field
      [name]="item.id"
      [formControl]="form.get(item.id)"
      iconSize="custom"
      iconWidth="48"
      iconHeight="48"
      class="rating-field"
      [class.rating-field-error]="
        form.get(item.id).dirty && form.get(item.id).invalid
      "
    >
    </i2g-rating-field>
    <i2g-error-message
      [dirty]="form.get(item.id).dirty"
      [invalid]="form.get(item.id).invalid"
      [errorMessage]="getRatingErrorMessage(item)"
    ></i2g-error-message>
  </div>

  <h2 class="comment-section-title">{{ commentSectionTitle }}</h2>

  <i2g-textarea-field
    fieldId="comment"
    [label]="commentLabel"
    [showLabel]="true"
    [fieldControl]="form.get(formKeys.COMMENT)"
    [placeholder]="commentPlaceholder"
    [errorMessages]="commentErrorMessages"
    rows="7"
    [maxlength]="commentMaxLength"
    class="comment-field"
    data-e2e-id="comment-field"
  >
  </i2g-textarea-field>

  <button
    type="submit"
    class="submit"
    i2gButton
    buttonStyle="emphasis"
    [disabled]="isSubmitProcessing"
    data-e2e-id="review-submit"
    (click)="onSubmitForm()"
  >
    <!-- couldn't use (submitForm) output event from <form> because the validation occurs after submit is clicked -->
    <i2g-icon
      *ngIf="isSubmitProcessing"
      class="loading-icon"
      [icon]="spinnerIcon"
    ></i2g-icon>
    {{ isSubmitProcessing ? processingLabel : buttonLabel }}
  </button>

  <p class="terms-conditions" [innerHTML]="termsConditionsLabel"></p>
</i2g-form-master>
